import { RSocket } from "./socket";
import { RosePacket } from "./rosepacket";

function logPacket(text: string, pak: any) {
    if (!config.fullPacketData) {
        let pakDataStr = "";
        if (pak.dataLength > 32) {
            pakDataStr = pak.toString(32) + " ...";
        } else {
            pakDataStr = pak.toString(pak.dataLength);
        }
        netConsole.debug(
            text + " <Packet " + pak.cmd.toString(16) + " " + pakDataStr + ">"
        );
    } else {
        netConsole.groupCollapsed(
            text + " <Packet " + pak.cmd.toString(16) + ">"
        );
        netConsole.debug(pak.toString(pak.dataLength));
        netConsole.groupEnd();
    }
}

function _checkPacket(pak: any) {
    if (pak.readPos > 0 && pak.readPos !== pak.dataLength) {
        console.warn(
            "Packet not read properly (cmd:" +
                pak.cmd.toString(16) +
                " length:" +
                pak.dataLength +
                " read:" +
                pak.readPos +
                ")."
        );
    }
}

export class RoseSocket extends RSocket {
    name: string;
    logIgnoreCmds: any[];

    constructor() {
        super();

        this.name = "";
        this.logIgnoreCmds = [];

        let headerBuf = new Uint8Array(6);
        let headerView = new DataView(headerBuf.buffer);
        let headerLen = 0;
        let dataLen = 0;
        let pakBuf: any = null;

        this.on("data", (data: Uint8Array) => {
            for (let i = 0; i < data.length; ++i) {
                if (!pakBuf) {
                    if (headerLen < 6) {
                        headerBuf[headerLen++] = data[i];
                    }
                    if (headerLen === 6) {
                        dataLen = headerView.getUint16(0, true) - 6;
                        // full inventories exceed the 4 KB default; a short buffer silently drops the tail
                        pakBuf = new RosePacket(0, Math.max(4096, dataLen));
                        pakBuf.cmd = headerView.getUint16(2, true);

                        if (dataLen === 0) {
                            if (this.logIgnoreCmds.indexOf(pakBuf.cmd) === -1) {
                                logPacket("net:recv", pakBuf);
                            }
                            this.emit("packet", pakBuf);
                            _checkPacket(pakBuf);
                            headerLen = 0;
                            dataLen = 0;
                            pakBuf = null;
                        }
                    }
                } else {
                    pakBuf.data[pakBuf.dataLength++] = data[i];

                    if (pakBuf.dataLength === dataLen) {
                        if (this.logIgnoreCmds.indexOf(pakBuf.cmd) === -1) {
                            logPacket("net:recv<" + this.name + ">", pakBuf);
                        }
                        this.emit("packet", pakBuf);
                        _checkPacket(pakBuf);
                        headerLen = 0;
                        dataLen = 0;
                        pakBuf = null;
                    }
                }
            }
        });
    }

    sendPacket(pak: any) {
        if (this.logIgnoreCmds.indexOf(pak.cmd) === -1) {
            logPacket("net:send<" + this.name + ">", pak);
        }
        const buf = pak.toBuffer();
        for (let i = 2; i < buf.length - 2; ++i) {
            buf[i] ^= 0x61;
        }
        this.send(buf.buffer);
    }
}

